module.exports = __webpack_public_path__ + "static/media/pr-1.5b0660c9.jpg";